import React, { useRef, useState } from 'react';
import StartStep from 'pages/ProListingSetup/components/StartStep';
import SetupStep from 'pages/ProListingSetup/components/SetupStep';
import { Button, Modal } from 'antd';
import { PATH } from 'constants/path';
import { useNavigate } from 'react-router-dom';
import EnrollImg from '../../imgs/prolisting-enroll.svg'

interface ProlistingSetupProps {
    onNext: () => void;
    onBack: () => void;
}

const ProlistingSetup = (props: ProlistingSetupProps) => {
    const { onNext, onBack } = props;
    const navigate = useNavigate();
    const [step, setStep] = useState('start');
    const [showEnrollModal, setShowEnrollModal] = useState(false);
    const setupStepRef = useRef<any>(null);

    const Steps = [
        { key: 'start', component: <StartStep showTalkToSpecialistButton /> },
        { key: 'setup', component: <SetupStep ref={setupStepRef} onConfirm={() => setShowEnrollModal(true)} /> },
    ];

    const handleNext = () => {
        if (step === 'start') {
            setStep('setup');
        } else {
            const isValid = setupStepRef.current?.validateForm();
            if (!isValid) {
                return;
            }
            setupStepRef.current?.handleSave();
        }
    };


    const handleBack = () => {
        if (step === 'setup') {
            setStep('start');
        } else {
            onBack();
        }
    };

    const handleSkip = () => {
        navigate(`${PATH.PPA_ONBOARDING_ADVANCE_SETTING_SUCCESS}`);
    };

    return (
        <div>
            {Steps.find((item) => item.key === step)?.component}
            <div className='flex gap-4 mb-9 mt-6'>
                <Button onClick={handleBack} className='bg-white'>Back</Button>
                <Button type='primary' onClick={handleNext}>Next</Button>
                <Button type='link' onClick={handleSkip}>Skip for now</Button>
            </div>
            <Modal open={showEnrollModal} onCancel={() => setShowEnrollModal(false)} footer={null}>
                <div className='flex flex-col items-center justify-center text-center'>
                    <img className='w-[150px] h-[150px]' src={EnrollImg} alt="Enroll" />
                    <div className='text-2xl font-semibold mb-2'>You’re enrolled in Pro-Listings</div>
                    <div className='text-base text-gray-500 mb-4'>Your Pro-Listings are now live and can help you reach more patients. Klarity will use your bid and budget settings to determine where and when to show your services.</div>
                    <div className='text-base text-gray-500 mb-6'>You can track performance and adjust your bid or budget anytime in Marketing.</div>
                    <Button
                        type='primary'
                        className='w-[120px]'
                        onClick={() => {
                            setShowEnrollModal(false);
                            onNext();
                        }}>
                        Next
                    </Button>
                </div>
            </Modal>
        </div>
    );
};

export default ProlistingSetup;